"use strict";

exports.__esModule = true;
exports.default = void 0;
var _underscore = _interopRequireDefault(require("./underscore.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
var _default = exports.default = _underscore.default.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};